import React, { useState } from 'react';

const Registration = () => {
  const [showUnderConstruction, setShowUnderConstruction] = useState(false);

  const handlePaymentClick = () => {
    setShowUnderConstruction(true);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <main className="content">
          <div className="card-box">
            <h1 style={{ margin: '0.0px 0.0px 16.1px 0.0px', font: '24.0px Times', color: '#1b5c71', WebkitTextStroke: '#1b5c71' }}>
              <b>Author Registration</b>
            </h1>
            <p>At least one author of each accepted paper must register for the conference for inclusion in IEEE Xplore.</p>
            <h2 style={{ margin: '0.0px 0.0px 14.9px 0.0px', font: '18.0px Times', color: '#1b5c71', WebkitTextStroke: '#1b5c71' }}>
              <b>Registration Guidelines</b>
            </h2>
            <ul>
              <li>Each paper requires at least one full registration.</li>
              <li>One registration covers one paper only.</li>
              <li>Additional papers require additional registration.</li>
              <li>Registration fees are non-refundable.</li>
              <li>All papers must be presented.</li>
            </ul>
            <h2 style={{ margin: '0.0px 0.0px 14.9px 0.0px', font: '18.0px Times', color: '#1b5c71', WebkitTextStroke: '#1b5c71' }}>
              <b>Registration Fee Structure</b>
            </h2>
            <h3 style={{ margin: '0.0px 0.0px 14.0px 0.0px', font: '14.0px Times', WebkitTextStroke: '#000000' }}>
              <b>Early Bird Registration</b>
            </h3>
            <table cellSpacing="0" cellPadding="0" style={{ borderCollapse: 'collapse', width: '100%' }}>
              <tbody>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center', fontWeight: 'bold' }}>
                    Category
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center', fontWeight: 'bold' }}>
                    Indian Authors (INR)
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center', fontWeight: 'bold' }}>
                    International Authors (USD)
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>IEEE Member</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹6400</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$130</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>Non-IEEE Member</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹8000</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$160</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>Industry Participant</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹9000</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$180</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>Student IEEE Member</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹5500</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$110</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>Student (Non-IEEE Member)</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹6500</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$130</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>Listener/Attendee</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹3000</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$60</td>
                </tr>
              </tbody>
            </table>
            
            <h3 style={{ margin: '20px 0px 14.0px 0.0px', font: '14.0px Times', WebkitTextStroke: '#000000' }}>
              <b>Late Registration</b>
            </h3>
            <table cellSpacing="0" cellPadding="0" style={{ borderCollapse: 'collapse', width: '100%' }}>
              <tbody>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center', fontWeight: 'bold' }}>
                    Category
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center', fontWeight: 'bold' }}>
                    Indian Authors (INR)
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center', fontWeight: 'bold' }}>
                    International Authors (USD)
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>IEEE Member</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹7400</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$140</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>Non-IEEE Member</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹9000</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$170</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>Industry Participant</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹10000</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$190</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>Student IEEE Member</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹6500</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$120</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>Student (Non-IEEE Member)</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹7500</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$140</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>Listener/Attendee</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>₹3000</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>$60</td>
                </tr>
              </tbody>
            </table>
            
            <h2 style={{ margin: '20px 0px 14.9px 0.0px', font: '18.0px Times', color: '#1b5c71', WebkitTextStroke: '#1b5c71' }}>
              <b>Payment Gateway</b>
            </h2>
            <ul>
              <li><b>Under Process</b></li>
            </ul>
            <p>After payment, upload proof or email to: <a href="mailto:dicon.dce@gmail.com">dicon.dce@gmail.com</a></p>
            <p>
              <button
                type="button"
                onClick={handlePaymentClick}
                style={{
                  backgroundColor: '#dc3545',
                  color: 'white',
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px',
                }}
              >
                Proceed to Payment
              </button>
            </p>
            {showUnderConstruction && (
              <div
                style={{
                  marginTop: '16px',
                  padding: '18px',
                  backgroundColor: '#fff9e6',
                  border: '1px solid #f0c36d',
                  borderRadius: '8px',
                  color: '#a55f00',
                  fontWeight: '700',
                  textAlign: 'center',
                }}
              >
                Page Under Construction
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Registration;
